import * as Sentry from '@sentry/tanstackstart-react';

Sentry.init({
  dsn: 'https://a186d0cbee0335ff9fbbf977adcfc6c8@o4507889463263232.ingest.de.sentry.io/4509548847956048',

  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,

});
